import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfiguracionActividadDto, IGetTipos, TipoDto } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/tipos`;

  constructor(private readonly http: HttpClient) {}

  getTipos(): Observable<IGetTipos[]> {
    return this.http.get<IGetTipos[]>(this.apiUrl);
  }

  editarActividades(id: number, request: ConfiguracionActividadDto[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/editar-actividades/${id}`, request);
  }

  createTipo(request: TipoDto): Observable<number> {
    return this.http.post<number>(this.apiUrl, request);
  }

  updateTipo(id: number, request: TipoDto): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/${id}`, request);
  }

  deleteTipo(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
  }

  setProduccion(id: number, produccion: boolean): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/produccion/${id}`,{ produccion} );
  }
}

